import { connect } from 'react-redux';

import App from './App';
import { selectors as userSelectors } from '../../dux/user';
import { selectors as orgSelectors, actionCreators } from '../../dux/org';
import { actionCreators as catalogActionCreators } from '../../dux/catalog';

const mapStateToProps = (state) => ({
  isAuthenticated: userSelectors.isAuthenticated(state),
  needsEmailVerification: userSelectors.needsEmailVerification(state),
  needsOrganization: userSelectors.needsOrganization(state),
  needsBilling: orgSelectors.needsBilling(state),
  user: userSelectors.getIdentityState(state),
  org: orgSelectors.getOrgState(state),
});

const mapDispatchToProps = {
  getOrg: actionCreators.getOrg,
  getServices: catalogActionCreators.getServices,
  getServiceSubtypes: catalogActionCreators.getServiceSubtypes,
  getProviders: catalogActionCreators.getProviders,
  getVersions: catalogActionCreators.getVersions,
  getRegions: catalogActionCreators.getRegions,
  getPlans: catalogActionCreators.getPlans,
  getFlavors: catalogActionCreators.getFlavors,
  getAddons: catalogActionCreators.getAddons,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
